import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../api/Service";
import { getErrorMessage } from "../../components/utils/errorHandler";
import { toast } from "react-toastify";
import { get, isEmpty, find, filter, has, debounce } from "lodash";
import history from "../../router/browserrouter";

export default function* watcherAutoLoginSaga() {
  yield takeEvery("AUTO_LOGIN", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "LOGIN_LOADING_BUTTON_SPINNER" });
    let payload = {};
    yield request("post", action.payload, "api/Authentication/auto-login").then(
      (response) => {
        payload = response;
      }
    );
    var roles = payload.roles;
    var user = payload.user;
    var token = payload.token;
    var cacNumber = null;
    yield request("get", {}, "api/Admin/get-industries").then((response) => {
      payload = response;
    });
    var cacNumber = "";
    yield put({ type: "SET_INDUSTRIES", payload: payload });
    yield put({ type: "PERSIST_CAC_NUMBER", payload: user.cacNumber });
    yield request("get", payload, "api/Admin/get-countries-dropdown").then(
      (response) => {
        payload = response;
      }
    );
   
    yield put({ type: "PERSIST_COUNTRIES", payload: payload });
    yield put({ type: "PERSIST_USER_ID", payload: user.id });
    cacNumber = user.cacNumber;
    if (cacNumber == "00000") {
      history.push("/add-company")
    }
    yield put({ type: "SET_FIRST_NAME", payload: user.firstName });
    yield put({ type: "SET_ROLES", payload: roles });
    yield put({ type: "PERSIST_ROLES", payload: roles });
    yield put({ type: "PERSIST_ORDER_ID", payload: 'null' });
    yield put({ type: "SET_USER_TYPE", payload: user.userType });
    yield put({ type: "SET_USER_ID", payload: user.id });
    localStorage.setItem("access_token", JSON.stringify(token));
    yield put({ type: "SET_ACCESS_TOKEN", payload: user.token });
    if (user.cacNumber !== "00000") {
      var url = "api/Company/cac?cacNumber=" + user.cacNumber;
      yield request("get", action.payload, url).then((response) => {
        payload = response;
      });
      var compId=0;
      yield put({ type: "COMPANY_ID", payload: payload.companyId });
      localStorage.setItem('companyId', payload.companyId)

      yield put({ type: "SET_CAC_NUMBER", payload: cacNumber });

      yield put({ type: "PERSIST_COMPANY_ID", payload: payload.companyId });
      yield put({ type: "PERSIST_COMPANY_NAME", payload: payload.companyName });
      var companyId = payload.companyId;

      yield request(
        "get",
        action.payload,
        "/api/Admin/get-location-count?companyId=" + companyId
      ).then((response) => {
        payload = response;
      });
      var locations = payload.locations;
      yield put({ type: "SET_LOCATIONS", payload: locations });
      yield request(
        "get",
        action.payload,
        "/api/Admin/get-product-category-count?companyId=" + companyId
      ).then((response) => {
        payload = response;
      });
      var productCategory = payload.productCategory;
      yield put({ type: "SET_PRODUCTCATEGORY", payload: productCategory });
      yield put({ type: "PERSIST_PRODUCT_CATEGORY", payload: productCategory });
    

      // New Request

      yield request("get", action.payload, "/get-inventory-dashboard").then(
        (response) => {
          payload = response;
        }
      );
      var inventoryValue = payload.inventoryValue;
      yield put({ type: "SET_INVENTORYVALUE", payload: inventoryValue });
      localStorage.setItem("inventoryValue", inventoryValue);

      // 
      yield request("get", action.payload, "/get-inventory-dashboard").then(
        (response) => {
          payload = response;
        }
      );
      var retailValue = payload.retailValue;
      yield put({ type: "SET_RETAILVALUE", payload: retailValue });
      localStorage.setItem("retailValue", retailValue);
      // 

      yield request("get", action.payload, "/get-inventory-dashboard").then(
        (response) => {
          payload = response;
        }
      );
      var potentialProfit = payload.potentialProfit;
      yield put({ type: "SET_POTENTIALPROFIT", payload: potentialProfit });
      localStorage.setItem("potentialProfit", potentialProfit);

      // 
      yield request("get", action.payload, "/get-inventory-dashboard").then(
        (response) => {
          payload = response;
        }
      );
      var grossMargin = payload.grossMargin;
      yield put({ type: "SET_GROSSMARGIN", payload: grossMargin });
      localStorage.setItem("grossMargin", grossMargin);

      // End of new Request

      // Sales EndPoints

      yield request("get", action.payload, "/get-sales-dashboard").then(
        (response) => {
          payload = response;
        }
      );
      var salesYearToDate = payload.salesYearToDate;
      yield put({ type: "SET_SALESYEARTODATE", payload: salesYearToDate });
      localStorage.setItem("salesYearToDate", salesYearToDate);

      // 

      yield request("get", action.payload, "/get-sales-dashboard").then(
        (response) => {
          payload = response;
        }
      );
      var salesMonthToDate = payload.salesMonthToDate;
      yield put({ type: "SET_SALESMONTHTODATE", payload: salesMonthToDate });
      localStorage.setItem("salesMonthToDate", salesMonthToDate);

      // 

      yield request("get", action.payload, "/get-sales-dashboard").then(
        (response) => {
          payload = response;
        }
      );
      var salesWeekToDate = payload.salesWeekToDate;
      yield put({ type: "SET_SALESMONTHTODATE", payload: salesWeekToDate });
      localStorage.setItem("salesWeekToDate", salesWeekToDate);

      //
      yield request("get", action.payload, "/get-sales-dashboard").then(
        (response) => {
          payload = response;
        }
      );
      var salesToday = payload.salesToday;
      yield put({ type: "SET_SALESTODAY", payload: salesToday });
      localStorage.setItem("salesToday", salesToday);

      yield request("get", action.payload, `api/Authentication/get-users-company?cacNumber=${cacNumber}`).then(
        (response) => {
          payload = response;
        }
      );
      var usersList = [];
      for (var i = 0; i < payload?.userInfo?.length; i++) {
        usersList.push({
          id: payload?.userInfo[i]?.id,
          title: payload?.userInfo[i]?.email,
        })
      }

      yield put({ type: "PERSIST_USER_DROP", payload: usersList });
      var url = "/api/Company/get-dashboard-datails/" + user.cacNumber;
      yield request("get", action.payload, url).then((response) => {
        payload = response;
      });
      yield put({ type: "SET_USER_COUNT", payload: payload.users });
      yield put({ type: "PERSIST_USERS", payload: payload.users });
      yield request(
        "get",
        action.payload,
        "/api/Admin/get-product-count?companyId=" + companyId
      ).then((response) => {
        payload = response;
      });
      var products = payload.products;
      yield put({ type: "SET_PRODUCTS", payload: products });
      yield put({ type: "PERSIST_PRODUCTS", payload: products });
    }

    yield put({ type: "DISPLAY_LOADER", payload: payload });

    const formatUrl = 'api/SalesTransactionV2/get-customers?companyId=' + companyId
    yield request("get", payload, formatUrl).then(response => {
      payload = response;
    });
    var customers = [];
    for (var i = 0; i < payload.length; i++) {
      customers.push({
        id: payload[i].id,
        title: payload[i].name
      })
    }
    yield request(
      "get",
      action.payload,
      "get-credit-details?companyId=" + companyId
    ).then((response) => {
      payload = response;
    });

    if (isEmpty(payload)) {
      history.push("/company-credit")
    } else {
      yield put({ type: "PERSIST_CREDIT", payload: payload });
      yield put({ type: "CUSTOMER_INFO_DROP", payload: customers })
      switch (roles[0]) {
        case "App Owner":
          return history.push("/home");
        case "Sales Representative":
          return history.push("/main/sales/dashboard");
        case "Inventory Manager":
          return history.push("/main/inventory");
        case "Inventory Manager":
          return history.push("/main/admin/dashboard");
        default:
          return history.push("/user/login");
      }
    }

  } catch (e) {
    console.log("login-saga", e.response);
    console.log("login-saga", e.response);
    yield put({ type: "LOGIN_LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
